import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "cell-container" }
const _hoisted_2 = { class: "flex-background" }
const _hoisted_3 = { class: "chat-help-text-display" }

import { ref, inject } from 'vue';
import { BeakerSession } from 'beaker-kernel/src';


export default /*@__PURE__*/_defineComponent({
  __name: 'ChatPanel',
  props: [
    "cellMap"
],
  setup(__props) {

const session = inject<BeakerSession>('session');

const props = __props


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "notebook-background")
    ]),
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "help-text")
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(session).notebook.cells, (cell, index) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(props.cellMap[cell.cell_type]), {
        cell: cell,
        key: index,
        class: "beaker-chat-cell"
      }, null, 8, ["cell"]))
    }), 128))
  ]))
}
}

})